import { render, staticRenderFns } from "./transitFetch.vue?vue&type=template&id=bdf6abd8&scoped=true"
import script from "./transitFetch.vue?vue&type=script&lang=js"
export * from "./transitFetch.vue?vue&type=script&lang=js"
import style0 from "./transitFetch.vue?vue&type=style&index=0&id=bdf6abd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf6abd8",
  null
  
)

export default component.exports